import { render, staticRenderFns } from "./search-location-item.vue?vue&type=template&id=ab20da74"
import script from "./search-location-item.vue?vue&type=script&lang=js"
export * from "./search-location-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports